import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  DeleteFloorRequest,
  DeleteFloorResponse,
  Floor,
  GetOrganizationFloorsRequest,
  PostFloorPlanImageRequest,
  PostFloorRequest,
  PostFloorResponse,
  PutFloorDevicesRequest
} from '../models/floor';
import {Simple200Response} from '../models/general';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class FloorPlanService {

  constructor(private httpClient: HttpClient) {
  }

  getOrganizationFloors({organizationToken}: GetOrganizationFloorsRequest): Observable<Floor[]> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/floors`;

    return this.httpClient
      .get<{ data: Floor[] }>(url, {headers})
      .pipe(
        map(response => response.data)
      );
  }

  postFloor({organizationToken, name}: PostFloorRequest): Observable<PostFloorResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${organizationToken}`,
      'Content-Type': 'application/json'
    });
    const url: string = `${environment.afbV2Host}orgs/self/floors`;
    const body = {name};

    return this.httpClient
      .post<PostFloorResponse>(url, body, {headers});
  }

  deleteFloor({organizationToken, floorId}: DeleteFloorRequest): Observable<DeleteFloorResponse> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}orgs/self/floors/${floorId}`;

    return this.httpClient
      .delete<DeleteFloorResponse>(url, {headers});
  }

  postFloorPlanImage({organizationToken, floorId, image}: PostFloorPlanImageRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}orgs/self/floors/${floorId}/floor-plan-snapshots/latest`;
    const formData: FormData = new FormData();
    formData.append('file', image);

    return this.httpClient
      .post<{ message: string }>(url, formData, {headers});
  }

  putFloorDevices({organizationToken, floorId, devices}: PutFloorDevicesRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url: string = `${environment.afbV2Host}orgs/self/floors/${floorId}/floor-plan-snapshots/latest/devices`;
    const body = {devices};

    return this.httpClient
      .put<{ message: string }>(url, body, {headers});
  }
}
